export const jobProfileManagementV2Route = {
    patterns: {
        jobProfileManagementV2: '/job-profile-management-v2',
    },
    titleTranslationKey: 'pages.job-profiles.headline',
} as const;
